import ChipColors from './ChipColors';

export default [
  {
    text: 'Pendente',
    value: 'Pending',
    ...ChipColors.wait,
  },
  {
    text: 'Em análise',
    value: 'Analysis',
    ...ChipColors.success,
  },
  {
    text: 'Reprovado',
    value: 'Reproved',
    ...ChipColors.danger,
  },
  {
    text: 'Estornado',
    value: 'Reversed',
    ...ChipColors.warning,
  },
];
